import { getCO2AequivalentSubscope1 } from './getCO2Aequivalent';
import { getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert, getCO2Scope3StructureAllgemein } from '../../bereiche/dateneingabe/functions/getCO2Scope3Structure';
import { getDatenqualitaet } from './getDatenqualitaet';
import { getStandorte } from '../../helpers/getStandorte';
import { getVeranstaltungen } from '../../helpers/getVeranstaltungen';
import { IDs } from '../../helpers/IDs';
import { isValid } from './validData';
import { jsonToSubscope7 } from '../../bereiche/dateneingabe/functions/jsonToSubscope7';
import { jsonToSubscope9 } from '../../bereiche/dateneingabe/functions/jsonToSubscope9';
import { Kennzahl } from './strukturiert/Kennzahl';
import { makeSimpleKennzahl } from './strukturiert/makeKennzahl';
import { processSubscope1 } from './CO2_subscopes/processSubscope1';
import { processSubscope2 } from './CO2_subscopes/processSubscope2';
import { processSubscope49 } from './CO2_subscopes/processSubscope49';
import { processAbwasserSubscope5, processSubscope5 } from './CO2_subscopes/processSubscope5';
import { processSubscope6 } from './CO2_subscopes/processSubscope6';
import { processSubscope7 } from './CO2_subscopes/processSubscope7';
import { processSubscope13 } from './CO2_subscopes/processSubscope13';
import { processSubscopeDatenqualitaet } from './CO2_subscopes/processSubscopeDatenqualitaet';
import { setKennzahlObj } from './strukturiert/KennzahlTools';

export function processKennzahlenBerechnungCO2Scope3(data: any, item: any, jahr: number, standort: any) {
    const standorte: any = {};
    const structs = [
        ...getCO2Scope3StructureVorgelagert(),
        ...getCO2Scope3StructureNachgelagert(),
        ...getCO2Scope3StructureAllgemein()
    ];
    [...(getStandorte(data) || []), ...(getVeranstaltungen(data) || [])]
        .forEach((item: any) => standorte[item.tid] = item);
    // Die Abzüge für Subscope 13 resetten
    item['co2_fussabdruck_abzug_kraftstoff_wert'] = undefined;
    item['co2_fussabdruck_abzug_strom_wert'] = undefined;
    item['co2_fussabdruck_abzug_fernwaerme_wert'] = undefined;
    item['co2_fussabdruck_abzug_waerme_wert'] = undefined;
    item['co2_fussabdruck_abzug_gase_wert'] = undefined;

    // ... unschön aber geht nicht anders
    structs.forEach((struct: any) => {
        if (struct.subscope === 3) { // Den Subscope 3 berechnen wir woanders
            return;
        }
        const part_addon = struct.part ? '_' + struct.part : '';
        // Hier filtern wir schonmal das Jahr vor, dann kann das später entfallen
        const entity = `co2_scope3_${struct.key}`;
        if (struct.subscope === 6 && jahr === 2021) {
            // console.log('SS6 ARR 1 :', jahr, entity, data[entity], standort);
        }
        let arr = (data[entity] || []).filter((row: any) => {
            // console.log('ARR49', isValid(row, entity), row);
            return +row.jahr === +jahr && (!standort || (standort.tid === row.standort_tid_orig)) && standorte[row.standort_tid_orig]
                && ((struct.subscope === 1 && isValid(row, entity, data)) || struct.subscope === 4 || struct.subscope === 9
                    || struct.subscope === 6 || struct.subscope === 7 || struct.subscope === 2 || isValid(row, entity, data));
        });
        /* if (struct.subscope === 13 && struct.part === 1 && +jahr === 2024) {
                  console.log('SSARR13:', jahr, entity, arr, standort, data[entity]);
              } */
        // Die äußere Schleife machen wir auch hier, das spart Code später
        const key_wert = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_wert`;
        const key_items = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_items`;
        if (item[key_wert]) {
            item[key_wert] = 0;
        }
        if (item[key_items]) {
            item[key_items] = [];
        }

        if (struct.subscope === 1) { // Wasser zu den Materialien
            processWasserSubscope1(data, item, jahr, standort);
        }
        if (struct.subscope === 5) { // Wasser/Abwasser zu den Abfall
            // console.log('S5 IN',  jahr, standort, arr, data[entity]);
            processAbwasserSubscope5(data, item, jahr, standort);
        }
        if (struct.key === 'pendeln' /* struct.subscope === 7 Kampagnedaten ausgeschlossen! */) {
            const kampaRows = (data[IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE] || []).filter((r: any) => (!standort || +r.standort_tid_orig === +standort.tid) && +r.jahr === +jahr && r.ergebnis);
            if (kampaRows.length > 0) {
                kampaRows.forEach((r: any) => {
                    let results;
                    try {
                        results = JSON.parse(r.ergebnis);
                    } catch (e) {
                        console.error(e, r);
                    }
                    if (results) {
                        const s7_rows = jsonToSubscope7(r.standort_tid_orig, r.tid, r.name, jahr, r.mitarbeiter, results, r.datenherkunft);
                        arr = [...arr, ...s7_rows];
                        // console.log('S7 IN', jahr, standort, s7_rows, results, kampaRows);
                    }
                });
            }
        }
        if (struct.subscope === 9) {
            const va_rows = (data[IDs.ENT_ANABREISE] || []).filter((r: any) => (!standort || +r.standort_tid_orig === +standort.tid) && +r.jahr === +jahr && r.ergebnis);
            if (va_rows && va_rows.length > 0) {
                va_rows.forEach((v: any) => {
                    let results;
                    try {
                        results = JSON.parse(v.ergebnis);
                    } catch (e) {
                        console.error(e, v);
                    }
                    if (results) {
                        const s9_rows = jsonToSubscope9(v.standort_tid_orig, v.tid, v.name, jahr, v.besucher, results, v.datenherkunft);
                        arr = [...arr, ...s9_rows];
                        // console.log('VA_Rows', +jahr, standort ? standort.tid : 0, arr, va_rows, data[IDs.ENT_ANABREISE]);
                    }
                });
            }

        }
        arr.forEach((row: any) => {
            if (struct.subscope === 1) { processSubscope1(row, data, item, jahr); }
            else if (struct.subscope === 2) { processSubscope2(row, data, item, jahr); }
            else if (struct.subscope === 4) { processSubscope49(row, data, item, jahr, arr, 4); }
            else if (struct.subscope === 5) { processSubscope5(row, data, item, jahr); }
            else if (struct.subscope === 6) { processSubscope6(row, data, item, jahr, arr); }
            else if (struct.key === 'pendeln' /* struct.subscope === 7 Kampagnedaten ausgeschlossen! */) { processSubscope7(row, data, item, jahr, arr); }
            else if (struct.subscope === 9) { processSubscope49(row, data, item, jahr, arr, 9); }
            else if (struct.subscope === 13 && struct.part) { processSubscope13(struct.part, row, data, item, jahr, arr, standort); }
            else { processSubscopeAllgemein(row, data, item, jahr, arr, struct.subscope); }

            if ([4, 6, 7, 9].indexOf(+struct.subscope) === -1) {
                processSubscopeDatenqualitaet(row, entity, struct.subscope, struct.part);
            }

            setKennzahlS3(struct, item, data);
        });
    });
    // An dieser Stelle stimmt die Gesamtsumme, d.h. wir können die Anteile ermitteln
    structs.forEach((struct: any) => {
        // Hier filtern wir schonmal das Jahr vor, dann kann das später entfallen
        const part_addon = struct.part ? '_' + struct.part : '';
        const key_wert = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_wert`;
        const key_anteil = `co2_fussabdruck_s3_ss${struct.subscope + part_addon}_anteil`;
        const anteil = (100 / item.co2_fussabdruck_total) * item[key_wert];
        item[key_anteil] = anteil;
    });
}

function setKennzahlS3(struct: any, item: any, data: any) {
    const itemsKey = `co2_fussabdruck_s3_ss${struct.subscope}_items`;
    const dataRows = item[itemsKey];
    if (Array.isArray(dataRows)) {
        dataRows.forEach((row: any) => {
            if (row.standort_tid_orig) {
                const kennKey = `s3_${struct.key}_${row.tid}`;

                // faktorKeysMenge & faktorKeysCo2
                // Siehe auch DatenauswertungCO2FussabdruckDetails.tsx
                let faktorKeysMenge: string[], faktorKeysCo2: string[];
                const isKampagne = (row.tid + '').startsWith('kampagne_');
                // 3.4, 3.6, 3.9 -> Nur Übernachtungen
                const isNurUebernachtung = row.transportmittel === 'uebernachtung' || row.transportmittel_mobilitaet === 'uebernachtung';
                if (isKampagne || isNurUebernachtung) {
                    faktorKeysMenge = Object.keys(row.faktor_map || {}).filter((k: string) => k === 'ÜN' && typeof row.faktor_map[k].menge === 'number');
                    faktorKeysCo2 = Object.keys(row.faktor_map || {}).filter((k: string) => k === 'ÜN' && typeof row.faktor_map[k].wert === 'number');
                } else {
                    faktorKeysMenge = Object.keys(row.faktor_map || {}).filter((k: string) => k !== 'ÜN' && typeof row.faktor_map[k].menge === 'number');
                    faktorKeysCo2 = Object.keys(row.faktor_map || {}).filter((k: string) => typeof row.faktor_map[k].wert === 'number');
                }

                // if (row.jahr === 2024 && struct.key === 'transport_nachgelagert') {
                //     console.log(row, kennKey, faktorKeysMenge, faktorKeysCo2);
                // }
                // if (+row.jahr === 2024 && (row.tid + '').startsWith('kampagne_')) {
                //     console.log(row, kennKey, faktorKeysMenge, faktorKeysCo2);
                // }
                // console.log(row.jahr, kennKey, row);

                if (faktorKeysMenge.length > 0) {
                    const rowCopy = { ...row };
                    // Menge (ohne ÜN)
                    faktorKeysMenge.forEach((fKey: string) => {
                        const fkt = row.faktor_map[fKey];
                        rowCopy.menge = fkt.menge;
                        const menge_einheit = fkt.menge_einheit || row.einheit;
                        const kennItem = setKennzahlObj({
                            standort_tid: row.standort_tid_orig,
                            data,
                            kennName: `Menge ${row.name}`,
                            bereich: Kennzahl.BEREICH_SCOPE3,
                            key: `${kennKey}_${fKey}`,
                            field: 'menge',
                            item: rowCopy,
                            einheit: menge_einheit,
                            einheitOrig: fkt.menge_einheitOrig,
                            gesamtKey: `${kennKey}_gesamt`,
                            gesamtName: `Menge ${row.name} Gesamt`,
                            faktor_um: fkt.wert_um,
                            faktor_um_info: fkt.faktor_um_info,
                            faktor_um_einheit: fkt.einheit_um,
                            faktor_um_quelle: fkt.quelle_um,
                            formel_um: fkt.formel_um,
                            // Custom-Faktoren
                            valueOrig: fkt.mengeOrig,
                            faktoren: fkt.faktoren
                        });
                        kennItem.setInfo(fkt.info || fKey);
                    });
                    // CO₂-Emission
                    faktorKeysCo2.forEach((fKey: string) => {
                        const fkt = row.faktor_map[fKey];
                        rowCopy.menge = fkt.menge;
                        const menge_einheit = fkt.menge_einheit || row.einheit;
                        let faktor = fkt.wert;
                        let einheit = fkt.einheit;
                        // g -> t
                        faktor = typeof faktor === 'number' ? faktor / 1000000 : faktor;
                        einheit = typeof einheit === 'string' ? einheit.replace('gCO2', 'gCO₂').replace('gCO₂', 'tCO₂') : einheit;
                        const co2Params = {
                            standort_tid: row.standort_tid_orig,
                            data,
                            kennName: `CO₂-Emission ${row.name}`,
                            bereich: Kennzahl.BEREICH_SCOPE3,
                            key: `${kennKey}_${fKey}_co2`,
                            field: 'menge',
                            item: rowCopy,
                            einheit: 'tCO₂Äq',
                            einheitOrig: fkt.menge_einheitOrig || menge_einheit,
                            gesamtKey: `${kennKey}_co2_gesamt`,
                            gesamtName: `CO₂-Emission ${row.name} Gesamt`,
                            faktor_um: fkt.wert_um_co2,
                            faktor_um_info: fkt.faktor_um_info,
                            faktor_um_einheit: fkt.einheit_um_co2,
                            faktor_um_quelle: fkt.quelle_um_co2,
                            faktor_co2: faktor,
                            faktor_co2_einheit: einheit,
                            faktor_co2_quelle: fkt.quelle,
                            formel_co2: fkt.formel_co2,
                            // Custom-Faktoren
                            valueOrig: fkt.mengeOrig,
                            faktoren: fkt.faktoren
                        };
                        const kennItem_f = setKennzahlObj(co2Params);
                        kennItem_f.setInfo(fkt.info || fKey);
                        // Gesamtemissionen SCOPE 3
                        setKennzahlS3Co2Gesamt(co2Params, struct);
                    });
                } else {
                    const rowCopy = { ...row };
                    setKennzahlObj({
                        standort_tid: row.standort_tid_orig,
                        data,
                        kennName: `Menge ${row.name}`,
                        bereich: Kennzahl.BEREICH_SCOPE3,
                        key: kennKey,
                        field: 'menge',
                        item: rowCopy,
                        einheit: row.einheit,
                        einheitOrig: row.einheitOrig,
                        formel_co2: row.formel_co2,
                        // Custom-Faktoren
                        valueOrig: row.mengeOrig,
                        faktoren: row.faktoren
                    });
                    // CO₂-Emission
                    let faktor, quelle, einheit;
                    if (row.faktor || row.faktor === 0) {
                        faktor = row.faktor;
                        quelle = row.quelle;
                    } else if (row.faktor_nutzer || row.faktor_nutzer === 0) {
                        faktor = row.faktor_nutzer;
                        quelle = row.quelle_nutzer;
                    }
                    einheit = row.faktor_einheit;
                    // g -> t
                    faktor = typeof faktor === 'number' ? faktor / 1000000 : faktor;
                    einheit = typeof einheit === 'string' ? einheit.replace('gCO2', 'gCO₂').replace('gCO₂', 'tCO₂') : einheit;
                    if (faktor || faktor === 0) {
                        const co2Params = {
                            standort_tid: row.standort_tid_orig,
                            data,
                            kennName: `CO₂-Emission ${row.name}`,
                            bereich: Kennzahl.BEREICH_SCOPE3,
                            key: `${kennKey}_co2`,
                            field: 'menge',
                            item: rowCopy,
                            einheit: 'tCO₂Äq',
                            einheitOrig: row.einheitOrig || row.einheit,
                            faktor_co2: faktor,
                            faktor_co2_einheit: einheit,
                            faktor_co2_quelle: quelle,
                            formel_co2: row.formel_co2,
                            // Custom-Faktoren
                            valueOrig: row.mengeOrig,
                            faktoren: row.faktoren
                        };
                        setKennzahlObj(co2Params);
                        // Gesamtemissionen SCOPE 3
                        setKennzahlS3Co2Gesamt(co2Params, struct);
                    }
                }
            }
        });
    }
}

export function setKennzahlS3Co2Gesamt(co2Params: any, struct: any) {
    // Kategorie
    const co2ParamsKategorie = {
        ...co2Params,
        key: `${co2Params.key}_temp1`,
        gesamtKey: `s3_co2_${struct.key}`,
        gesamtName: `Gesamtemissionen - ${struct.name}`,
        hidden: true
    }
    setKennzahlObj(co2ParamsKategorie);

    // Gesamtemissionen SCOPE 3
    const co2ParamsGesamt = {
        ...co2Params,
        key: `${co2Params.key}_temp2`,
        gesamtKey: `s3_co2_gesamt`,
        gesamtName: `Gesamtemissionen SCOPE 3`,
        hidden: true
    }
    setKennzahlObj(co2ParamsGesamt);
}

function processSubscopeAllgemein(row: any, data: any, item: any, jahr: number, arr: any[], subscope: number) {
    row = { ...row };
    if (subscope === 16 && row.ghg_kategorie) {
        // console.log('Allg (16): ', subscope, row);
        const ghg_kategorie = row.ghg_kategorie;
        // Nicht schön, aber der sicherste Weg ...
        switch (ghg_kategorie) {
            case 'gueter_einkauf':
                subscope = 1;
                break;
            case 'gueter_kapital':
                subscope = 2;
                break;
            case 'brennstoff':
                subscope = 3;
                break;
            case 'transport_vorgelagert':
                subscope = 4;
                break;
            case 'abfall':
                subscope = 5;
                break;
            case 'reisen':
                subscope = 6;
                break;
            case 'pendeln':
            case 'pendeln_kampagne':
                subscope = 7;
                break;
            case 'angemietete_sachanlagen':
                subscope = 8;
                break;
            case 'transport_nachgelagert':
            case 'anreise_kampagne':
                subscope = 9;
                break;
            case 'produkte_verarbeitung':
                subscope = 10;
                break;
            case 'produkte_nutzung':
                subscope = 11;
                break;
            case 'produkte_lebenszyklus':
                subscope = 12;
                break;
            case 'vermietete_sachanlagen':
            case 'vermietete_sachanlagen_raeumlichkeiten':
            case 'vermietete_sachanlagen_fahrzeuge':
            case 'vermietete_sachanlagen_technik':
                subscope = 13;
                break;
            case 'franchise':
                subscope = 14;
                break;
            case 'investition':
                subscope = 15;
                break;
            default:
        }
    }
    const key_wert = `co2_fussabdruck_s3_ss${subscope}_wert`;
    const key_items = `co2_fussabdruck_s3_ss${subscope}_items`;
    if (!item[key_items]) {
        item[key_items] = [];
    }
    if (row.bemerkung) {
        row.name += ' | ' + row.bemerkung;
    }
    const faktor = row.faktor;
    const menge = row.menge;
    if (row.emissionsangabe && row.emissionsangabe === 'emissionen_absolut') {
        row.value = row.co2_gesamt / 1000;
        row.faktor = 'absolut';
    } else if (menge && faktor) {
        row.value = (faktor * menge) / 1000;
        row.faktor_einheit = 'gCO₂Äq/' + row.einheit;
        row.faktor = row.faktor * 1000;
        row.quelle = `Eingabe durch Nutzer:in${row.quelle ? ` / Quelle: ${row.quelle}` : ''}`;
    }
    // console.log('SS' + subscope + ' Item', menge, faktor, row);
    if (row.value) {
        item[key_items].push(row);
        item[key_wert] = (item[key_wert] || 0) + row.value;
        item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + row.value;
        item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + row.value;

        // Kennzahl erstellen
        makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss' + subscope + '_' + row.tid, jahr, row.standort_tid_orig, row.tid,
            'Menge', row.name, row.menge, row.value, row.einheit,
            row.faktor, row.quelle, data);
    }
}

function processWasserSubscope1(data: any, item: any, jahr: number, standort: any) {
    const arr = (data[IDs.ENT_ENERGIEDATEN_WASSER] || []).filter((row: any) =>
        +row.jahr === +jahr && (!standort || (standort.tid === row.standort_tid_orig)) && isValid(row, IDs.ENT_ENERGIEDATEN_WASSER)
    );
    const key_wert = 'co2_fussabdruck_s3_ss1_wert';
    const key_items = 'co2_fussabdruck_s3_ss1_items';

    if (!item[key_items]) {
        item[key_items] = [];
    }
    // console.log('SS1_WASSER:', item);
    const menge = item.wasser_verbrauch_jahr;
    if (!menge) {
        return;
    }
    const faktor = getCO2AequivalentSubscope1(data, jahr, 'Wasser');
    const value = faktor.wert * (menge);
    const row_wasser: any = {};
    row_wasser.value = value;
    row_wasser.name = faktor.name;
    row_wasser.quelle = faktor.quelle;
    row_wasser.menge = menge;
    row_wasser.einheit = 'm³';
    row_wasser.faktor_einheit = 'gCO₂Äq/m³';
    row_wasser.faktor = faktor.wert * 1000000;
    row_wasser.datenqualitaet = getDatenqualitaet(item.wasser_datenqualitaet || []);
    row_wasser.kategorie_tid = 'Wasser';
    row_wasser.tid = 'wasser';
    item[key_items].push(row_wasser);
    // console.log('SS1_Wasser: ', row_wasser, row);
    item[key_wert] = (item[key_wert] || 0) + value;
    // console.log('SS1 - IN: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + value;
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + value;
    const rowCopy = { ...row_wasser, jahr };
    const structure: any = (getCO2Scope3StructureVorgelagert() || []).find((subscopes: any) => subscopes.subscope === 1) || {};
    const kennKey = `s3_${structure.key}_${rowCopy.tid}`;
    const standort_tid = (standort || {}).tid;
    setKennzahlObj({
        standort_tid,
        data,
        kennName: `Menge ${rowCopy.name}`,
        bereich: Kennzahl.BEREICH_SCOPE3,
        key: kennKey,
        field: 'menge',
        item: rowCopy,
        einheit: rowCopy.einheit
    });
    const co2Params: any = {
        standort_tid,
        data,
        kennName: `CO₂-Emission ${row_wasser.name}`,
        bereich: Kennzahl.BEREICH_SCOPE3,
        key: `${kennKey}_co2`,
        field: 'menge',
        item: rowCopy,
        einheit: 't',
        einheitOrig: rowCopy.einheit,
        faktor_co2: faktor.wert,
        faktor_co2_einheit: 't/m³',
        faktor_co2_quelle: rowCopy.quelle
    };
    setKennzahlObj(co2Params);
    // Gesamtemissionen SCOPE 3
    setKennzahlS3Co2Gesamt(co2Params, structure);
}
